import React, { Component, ComponentType } from 'react';
import logo from '../../../assets/sightXLogoUiRefresh.png';
import { SignUpTier } from './types';
import { Logo } from '../login/logo/Logo';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

import styles from './withSignUp.module.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
export const withSignUp = (SignUpComponent: ComponentType<any>) => {
  interface IComponentProps {
    tier?: SignUpTier;
  }

  return class SignUp extends Component<IComponentProps> {
    private renderLogo() {
      if (isFeatureEnabled(Features.Netquest)) {
        return <Logo />;
      }
      return <div className={styles.logo}>
        <img src={logo} alt="SightX Logo" />
      </div>;
    }

    private renderForm() {
      return (
        <div className={styles.loginForm}>
          {this.renderLogo()}
          <SignUpComponent {...this.props} />
        </div>
      );
    }

    render() {
      return (
        <div className={styles.signUp}>
          {this.renderForm()}
        </div>
      );
    }
  };
};
